import './Markdown.css';
export var MarkdownWrapperCSS = '_evdqaz0-2-0-1';